<div class="lum-c-assembly-order-list">
  <mat-tab-group class="lum-page__ag-grid__tab-group lum-page">
    <mat-tab label="Orders">
      <div
        class="
          lum-page lum-page__card lum-c-sales-order-ag-table position-relative lum-c-sales-order-ag-table__article
        "
      >
        <header class="lum-page-header">
          <h2 class="lum-page-header__heading">Assembly Orders</h2>
          <div class="lum-page-header__actions">
            <a class="lum-button" [routerLink]="['/assembly-orders/create']">
              <i class="fas fa-plus mr-2"></i>
              Create Assembly Order
            </a>
            <a
              class="lum-button"
              [routerLink]="['/assembly-orders/disassembly/create']"
            >
              <i class="fas fa-minus mr-2"></i>
              Create Disassembly Order
            </a>
          </div>
        </header>

        <div class="lum-page-nav">
          <ng-content [select]="sidemenu"></ng-content>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Items"> </mat-tab>
  </mat-tab-group>
</div>
